export default __webpack_public_path__ + "static/media/ISSO CLASS-6 EXAM PATTERN 2026-27.36b87338.pdf";